import React, { useEffect, useState } from "react";
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import LinearProgress from '@material-ui/core/LinearProgress';

import { makeStyles } from '@material-ui/core/styles';

import { Framework } from '@flint/framework';
import { inject, observer } from 'mobx-react';

const handleBackClick = () => {
    window.history.back();
};

const useStyles = makeStyles((theme) => ({
    paper: {
        width: "100%",
        padding: theme.spacing(2),
    },
    title: {
        flex: '1 1 100%',
        fontFamily: "Merriweather",
        fontStyle: "normal",
        fontWeight: "bold",
        fontSize: "28px",
        lineHeight: "90px",
        color: "#222747",
    },
    form: {
        display: "flex",
        flexDirection: "column",
    },
    formLabel: {
        flex: "1",
        fontSize: "17px",
        fontFamily: "Nunito Sans",
        fontStyle: "normal",
        lineHeight: "30px",
        color: "#000000",
    },
    formInput: {
        border: "1px solid #D3D6E1",
        boxSizing: "border-box",
        borderRadius: "2px",
        fontFamily: "Nunito Sans",
        fontStyle: "normal",
        fontWeight: "normal",
        fontSize: "16px",
        lineHeight: "30px", color: "#8E96AC",
    },
    button: {
        color: "#FFF",
        padding: "15px",
        fontSize: "18px",
        fontFamily: "Nunito Sans",
        fontStyle: "normal",
        fontWeight: "bold",
        lineHeight: "20px",
        background: "#222747",
        borderRadius: "3px",
        textTransform: "unset",
        transition: "background 0.25s",
        border: "2px solid #222747",
        maxHeight:"55px",
        "&:hover": {
            background: "none",
            color: "#222747",
        }
    },
    mtop: {
        marginTop: theme.spacing(2),
    },
    mleft: {
        marginLeft: theme.spacing(2),
    },
    addIcon: {
        height: "28px",
        width: "28px",
    }
}));


const EPubForm = ({ EPubUploadStore, EPubUploadStoreStatus }) => {

    const classes = useStyles();

    const [formError,setFormError] =useState({error:false,helperText:"Please select a file..."});
    const [epubFile,setEpubFile]=React.useState({name:""});
    const epubInputFileRef=React.useRef();

    const [btnText, setBtnText] = useState('Upload');
    const [btnStyle, setBtnStyle] = useState({});

    const [open, setOpen] = React.useState(false);

    const handleClose = () => {
        setOpen(false);
        setBtnText("Submit");
        setBtnStyle({});
        setEpubFile({name:""});
    };

    const handleGoToHome = () => {
        Framework.redirect(`/`);
    }

    

    const submitEpub = (e) => {
        e.preventDefault();
        if(epubFile.name===""){
            setFormError({...formError,error:true});
        }
        else {
            setBtnStyle({
                "pointerEvents": "none",
                "opacity": "0.5",
            })
            setBtnText('Uploading...');
            setFormError({...formError,error:false});
            EPubUploadStore.fetch(epubFile);
            setOpen(true);
            EPubUploadStore.reset();
        }
        epubInputFileRef.current.value="";
    }
    const fileNameAdd = (e) => {
        setEpubFile(e.target.files[0]);
    }

    useEffect(() => {
        document.title = "Upload ePUB"
    })
    
    return (
        <>
            {EPubUploadStoreStatus.isPending ? <LinearProgress color="secondary" /> : <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">ePub Upload</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {EPubUploadStore.res}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary" autoFocus>
                        Upload More
                    </Button>
                    <Button onClick={handleGoToHome} color="primary">
                        Go To Home
                    </Button>
                </DialogActions>
            </Dialog>}
            <Box display="flex" justifyContent="center" p={4}>

                <Grid item xs={12} sm={10} md={8} lg={6}>
                    <Paper className={classes.paper}>
                        <Tooltip title="Go back">
                            <IconButton onClick={handleBackClick}>
                                <ArrowBackIcon className={classes.addIcon} />
                            </IconButton>
                        </Tooltip>
                        <Typography className={classes.title} variant="h1" id="tableTitle" component="div">
                            ePub Upload
                    </Typography>
                        <form className={classes.form}>
                            <Grid container justify="space-between" spacing={1}>
                                <TextField className={classes.formLabel} disabled id="outlined-basic" placeholder="Upload ePub File" variant="outlined" value={epubFile.name} {...formError.error?formError:null} />
                                <Button className={`${classes.button} ${classes.mleft}`} variant="contained" component="label">
                                    Select Book<input type="file" hidden id="epubFile" name="file" ref={epubInputFileRef} onChange={fileNameAdd} accept=".epub" />
                                </Button>
                            </Grid>
                            <Grid container justify="center" p={1} className={classes.mtop}>
                                <Button className={classes.button} style={btnStyle} variant="contained" component="label" onClick={submitEpub}>{btnText}</Button>
                            </Grid>
                        </form>
                    </Paper>
                </Grid>
            </Box >
        </>
    )
}

export default inject('EPubUploadStore', 'EPubUploadStoreStatus')(observer(EPubForm));